/* Maharaja Home - behaviour for every mm-home section.
   Each section root ([data-mm-home]) is set up on its own, so sections can be added, removed,
   reordered and reloaded in the theme editor. Scroll effects use GSAP + ScrollTrigger (loaded
   once from cdnjs); without them, with reduced motion or in the theme editor the page stays
   static and fully usable. */
(function () {
  'use strict';
  // every section includes this file; run it once
  if (window.__mmHome) return;
  window.__mmHome = true;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const html = document.documentElement;

  const SVG = (paths, fill) => `<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${fill ? paths.replace(/<path /g, '<path fill="currentColor" stroke="none" ') : paths}</svg>`;
  const ICON = {
    play: SVG('<path d="M8 5.5v13l10.5-6.5Z"/>', true),
    pause: SVG('<path d="M8 5.5h2.6v13H8zM13.4 5.5H16v13h-2.6z"/>', true),
    muted: SVG('<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z"/><path d="m16 9.5 5 5m0-5-5 5"/>'),
    sound: SVG('<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>'),
    ig: SVG('<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r=".6" fill="currentColor"/>')
  };
  // where the theme has the icon (snippets/mm-theme-icons-template.liquid), use it; the theme has no sound icons
  const themeIcons = document.getElementById('mm-theme-icons');
  if (themeIcons) for (const k of Object.keys(ICON)) {
    const el = themeIcons.content.querySelector(`[data-icon="${k}"]`);
    if (el) ICON[k] = el.innerHTML.trim();
  }

  /* ---------------- theme header: keep sticky parts and the hero clear of it ---------------- */
  let hdrEls = [];
  const findHeaders = () => {
    hdrEls = $$('header, [id*="header" i], [class*="header" i], sticky-header').filter(el => {
      if (el.closest('[data-mm-home]')) return false;
      const cs = getComputedStyle(el);
      return (cs.position === 'fixed' || cs.position === 'sticky') && cs.display !== 'none' && el.offsetHeight > 0 && el.offsetHeight < 240;
    });
    // the hero fills the screen below the header
    html.style.setProperty('--mm-header-h', Math.round(hdrEls.reduce((h, el) => Math.max(h, el.getBoundingClientRect().bottom > 0 ? el.offsetHeight : 0), 0)) + 'px');
  };
  // visible header height right now (themes often hide the header while scrolling down)
  const headerOffset = () => {
    let h = 0;
    hdrEls.forEach(el => { const r = el.getBoundingClientRect(); if (r.top <= 1 && r.height < 240 && r.bottom > h) h = r.bottom; });
    return Math.max(0, Math.round(h));
  };
  let hTick = false;
  // the Maharaja header sets the offset itself (mm-header.js), to where it is going as its slide starts;
  // measuring here as well overwrote that
  const ownHeader = () => !!document.querySelector('#header-group .mm-hdr');
  const setOffset = () => { if (!ownHeader()) html.style.setProperty('--mm-header-offset', headerOffset() + 'px'); hTick = false; };
  addEventListener('scroll', () => { if (!hTick) { hTick = true; requestAnimationFrame(setOffset); } }, { passive: true });
  addEventListener('resize', () => { findHeaders(); setOffset(); });

  /* ---------------- toasts + cursor (one each, on <body>) ---------------- */
  let toastBox = null;
  const toast = (msg, link) => {
    if (!toastBox) { toastBox = document.createElement('div'); toastBox.className = 'mm-home-toasts'; toastBox.setAttribute('aria-live', 'polite'); document.body.appendChild(toastBox); }
    const t = document.createElement('div');
    t.className = 'mm-home-toast'; t.textContent = msg;
    if (link) { const a = document.createElement('a'); a.href = link.href; a.textContent = link.label; t.appendChild(a); }
    toastBox.appendChild(t); setTimeout(() => t.remove(), 3300);
  };

  const startCursor = () => {
    if (!fine || reduce || $('.mm-home-cursor')) return;
    const c = document.createElement('div');
    c.className = 'mm-home-cursor'; c.setAttribute('aria-hidden', 'true'); document.body.appendChild(c);
    let x = -200, y = -200, cx = x, cy = y, sc = 0, ts = 0, running = false;
    const loop = () => {
      cx += (x - cx) * .2; cy += (y - cy) * .2; sc += (ts - sc) * .18;
      c.style.transform = `translate3d(${cx}px,${cy}px,0) scale(${sc.toFixed(3)})`;
      // stop the loop once the cursor has faded out, so it costs nothing while unused
      if (ts || sc > .002) requestAnimationFrame(loop); else { running = false; c.style.transform = 'translate3d(-200px,-200px,0) scale(0)'; }
    };
    addEventListener('pointermove', e => {
      x = e.clientX; y = e.clientY;
      const t = e.target.closest && e.target.closest('[data-mm-home] [data-cursor]');
      const inner = e.target.closest && e.target.closest('button, .pc-name a, .pc-quick, .pc-add, .pill, .reel-prod, .oc-name a, .oc-act');
      ts = t && !inner ? 1 : 0;
      if (t) c.textContent = t.dataset.cursor;
      if (ts && !running) { running = true; cx = x; cy = y; requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('pointerleave', () => { ts = 0; });
  };

  /* ---------------- quick add to cart (cards with a single variant) ---------------- */
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('[data-mm-home] form[data-mm-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    if (form.dataset.mmAdding === '1') return;
    form.dataset.mmAdding = '1';
    const btn = $('button', form); if (btn) btn.disabled = true;
    const body = new FormData(form);
    const drawer = $('cart-drawer');
    const viaDrawer = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
    if (viaDrawer) {
      body.append('sections', drawer.getSectionsToRender().map(section => section.id));
      body.append('sections_url', location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body })
      .then(r => r.json().then(d => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error(d.description || d.message || 'Could not add this saree');
        toast('Added to your cart', { href: root + 'cart', label: 'View cart' });
        // Notify Ella's cart subscribers and refresh the drawer's rendered sections.
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-home', productVariantId: body.get('id'), cartData: d }); } catch (e) { }
        if (viaDrawer) drawer.renderContents(d);
        document.dispatchEvent(new CustomEvent('mm:cart:add', { bubbles: true, detail: d }));
        fetch(root + 'cart.js').then(r => r.json()).then(cart => {
          $$('.cart-bubble').forEach(el => el.classList.toggle('visually-hidden', !cart.item_count));
          $$('.cart-bubble__text-count').forEach(el => el.classList.toggle('hidden', !cart.item_count));
          $$('.cart-bubble__text-count span[aria-hidden], .cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(el => { el.textContent = cart.item_count < 100 ? cart.item_count : '99+'; });
        }).catch(() => { });
      })
      .catch(err => toast(err.message || 'Could not add this saree'))
      .finally(() => { delete form.dataset.mmAdding; if (btn) btn.disabled = false; });
  });

  /* ---------------- product cards: quick view + wishlist hearts, as on the Shop page ---------------- */
  // the Shop's quick view drawer (mm-shop.js + .css) is fetched on the first click only
  let shopLib = null;
  const loadShop = () => {
    if (window.mmShopQuick) return Promise.resolve();
    if (shopLib) return shopLib;
    const a = window.mmShopAssets || {};
    shopLib = new Promise((res, rej) => {
      if (a.css && !document.querySelector(`link[href="${a.css}"]`)) { const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = a.css; document.head.appendChild(l); }
      if (!a.js) { rej(new Error('no quick view')); return; }
      const s = document.createElement('script'); s.src = a.js; s.async = true;
      s.onload = () => (window.mmShopQuick ? res() : rej(new Error('no quick view'))); s.onerror = rej;
      document.head.appendChild(s);
    }).catch(err => { shopLib = null; throw err; });
    return shopLib;
  };
  document.addEventListener('click', e => {
    const q = e.target.closest && e.target.closest('[data-mm-home] [data-quick]');
    if (!q) return;
    e.preventDefault();
    q.setAttribute('aria-busy', 'true');
    loadShop()
      .then(() => window.mmShopQuick(q.dataset.quick, q))
      .catch(() => { const card = q.closest('.pc'), a = card && card.querySelector('.pc-name a'); if (a) location.href = a.href; })
      .finally(() => q.removeAttribute('aria-busy'));
  });
  // the theme's <wish-list> only toggles on click: mark the sarees already saved (localStorage "wishlistItem")
  const syncWishlist = () => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('wishlistItem')) || []; } catch (e) { list = []; }
    $$('[data-mm-home] [data-wishlist-handle]').forEach(b => {
      const on = list.indexOf(b.dataset.wishlistHandle) > -1;
      b.classList.toggle('wishlist-added', on);
      b.setAttribute('aria-pressed', on);
    });
  };
  document.addEventListener('add:wishlist-item', syncWishlist);
  document.addEventListener('remove:wishlist-item', syncWishlist);
  document.addEventListener('shopify:section:load', syncWishlist);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncWishlist); else syncWishlist();

  /* ---------------- in-page links: smooth scroll below the theme header ---------------- */
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-mm-home] a[href^="#"]');
    if (!a) return;
    let id;
    try { id = decodeURIComponent(a.getAttribute('href').slice(1)); } catch (err) { return; }
    const t = id && document.getElementById(id);
    if (!t) { if (id === '' || id === '#') e.preventDefault(); return; }
    e.preventDefault();
    const top = t.getBoundingClientRect().top + scrollY - headerOffset() - 8;
    scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    history.replaceState(null, '', '#' + id);
  });

  /* ---------------- GSAP + ScrollTrigger, loaded once ---------------- */
  let libs = null;
  const loadScript = src => new Promise((res, rej) => {
    const s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s);
  });
  const loadLibs = () => {
    if (!libs) {
      libs = (window.gsap ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js'))
        .then(() => window.ScrollTrigger ? null : loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js'))
        .then(() => { window.gsap.registerPlugin(window.ScrollTrigger); return window.gsap; });
    }
    return libs;
  };
  // ScrollTrigger.refresh() jumps the page to the top and back to measure, which cancels a smooth
  // scroll in progress (back-to-top stopped halfway, on a dark section under the header). Lazy
  // images finish loading during exactly such scrolls, so wait until the page has stopped moving.
  let refreshTimer = null, lastScroll = 0;
  addEventListener('scroll', () => { lastScroll = performance.now(); }, { passive: true });
  const runRefresh = () => {
    if (performance.now() - lastScroll < 250) { refreshTimer = setTimeout(runRefresh, 250); return; }
    window.ScrollTrigger.refresh();
  };
  const refreshST = () => { if (!window.ScrollTrigger) return; clearTimeout(refreshTimer); refreshTimer = setTimeout(runRefresh, 120); };

  /* position:sticky fails inside an overflow:hidden/auto ancestor. Theme wrappers that only clip
     (not real scrollers) are switched to overflow:clip, which looks the same but lets sticky work.
     Returns a function that puts the wrappers' own inline values back (used when the section unloads). */
  const unblockSticky = el => {
    const changed = [];
    for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      const cs = getComputedStyle(p);
      if (!/(auto|scroll|hidden)/.test(cs.overflowX + ' ' + cs.overflowY)) continue;
      const scrolls = /(auto|scroll)/.test(cs.overflowY) && p.scrollHeight > p.clientHeight + 1;
      if (scrolls || cs.overflowX === 'scroll' || cs.overflowY === 'scroll') break;
      changed.push([p, p.style.overflowX, p.style.overflowY]);
      p.style.overflowX = cs.overflowX === 'visible' ? 'visible' : 'clip';
      p.style.overflowY = cs.overflowY === 'hidden' ? 'clip' : 'visible';
    }
    return () => changed.forEach(([p, x, y]) => { p.style.overflowX = x; p.style.overflowY = y; });
  };

  /* =====================================================================
     One section
     ===================================================================== */
  function init(rootEl) {
    if (!rootEl || rootEl.dataset.mmReady) return;
    rootEl.dataset.mmReady = '1';
    const ac = new AbortController();
    const opt = { signal: ac.signal };
    const passive = { passive: true, signal: ac.signal };
    const cleanups = [];
    rootEl._mmDestroy = () => { ac.abort(); cleanups.forEach(f => { try { f(); } catch (e) { } }); };
    rootEl.classList.add('mm-js');

    /* ---------- weave reveal: build strips ---------- */
    const STRIPS = 10;
    $$('[data-weave]', rootEl).forEach(w => {
      if (reduce) return;
      const img = $('img', w);
      if (!img || designMode) return;
      for (let i = 0; i < STRIPS; i++) {
        const s = document.createElement('div');
        s.className = 'weave-strip';
        s.style.clipPath = `inset(${(i * 100 / STRIPS).toFixed(3)}% 0 ${(100 - (i + 1) * 100 / STRIPS).toFixed(3)}% 0)`;
        // mobile strips start off-canvas and slide in with CSS; desktop strips are scrubbed by GSAP
        if (w.dataset.weave === 'mob') s.style.transform = `translateX(${i % 2 ? 105 : -105}%)`;
        s.style.setProperty('--i', i);
        const c = img.cloneNode(); c.alt = ''; c.removeAttribute('loading'); s.appendChild(c);
        w.appendChild(s);
      }
      w.classList.add('is-built');
      if (w.dataset.weave === 'mob') w.classList.add('is-css');
    });

    /* ---------- base reveals (IntersectionObserver) ---------- */
    const counted = new WeakSet();
    const countUp = el => {
      if (counted.has(el)) return; counted.add(el);
      const to = parseFloat(el.dataset.count) || 0, suf = el.dataset.suffix || '';
      if (reduce || designMode) { el.textContent = to + suf; return; }
      const t0 = performance.now(), dur = 1600;
      (function f(t) { const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e) + suf; if (p < 1) requestAnimationFrame(f); })(t0);
    };
    $$('[data-reveal-group]', rootEl).forEach(g => Array.from(g.children).forEach((c, i) => { if (!c.style.getPropertyValue('--i')) c.style.setProperty('--i', i % 8); }));
    $$('.sc-panel', rootEl).forEach(g => Array.from(g.children).forEach((c, i) => c.style.setProperty('--i', i % 8)));
    const revealTargets = $$('[data-reveal], [data-reveal-group], [data-zari], .weave.is-css', rootEl);
    // [data-unveil] starts fully clipped, and IntersectionObserver honours the target's own clip-path,
    // so unveils are watched through their parent element instead
    const unveilByParent = new Map();
    $$('[data-unveil]', rootEl).forEach(u => { const p = u.parentElement; if (!unveilByParent.has(p)) unveilByParent.set(p, []); unveilByParent.get(p).push(u); });
    if (designMode || !('IntersectionObserver' in window)) {
      // the theme editor shows everything straight away
      revealTargets.forEach(el => el.classList.add('in'));
      unveilByParent.forEach(list => list.forEach(u => u.classList.add('in')));
      $$('[data-count]', rootEl).forEach(countUp);
    } else {
      const io = new IntersectionObserver(entries => entries.forEach(en => {
        if (!en.isIntersecting) return;
        const el = en.target;
        if (!el.matches('[data-unveil-parent]') || el.matches('[data-reveal], [data-reveal-group], [data-zari], .weave')) el.classList.add('in');
        (unveilByParent.get(el) || []).forEach(u => u.classList.add('in'));
        $$('[data-count]', el).forEach(countUp);
        io.unobserve(el);
      }), { threshold: .12, rootMargin: '0px 0px -40px 0px' });
      unveilByParent.forEach((_, p) => { p.setAttribute('data-unveil-parent', ''); io.observe(p); });
      revealTargets.forEach(el => io.observe(el));
      cleanups.push(() => io.disconnect());
    }

    /* ---------- rows: arrows + mouse drag ---------- */
    const row = $('[data-row]', rootEl);
    if (row) {
      const stepOf = () => { const c = row.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 20) : row.clientWidth * .8; };
      $$('[data-row-prev],[data-row-next]', rootEl).forEach(b => b.addEventListener('click', () => {
        row.scrollBy({ left: (b.hasAttribute('data-row-prev') ? -1 : 1) * stepOf(), behavior: reduce ? 'auto' : 'smooth' });
      }, opt));
    }
    $$('[data-drag]', rootEl).forEach(r => {
      let down = false, sx = 0, sl = 0, moved = false;
      r.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button) return; down = true; moved = false; sx = e.clientX; sl = r.scrollLeft; }, opt);
      addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; r.classList.add('is-dragging'); } r.scrollLeft = sl - dx; }, opt);
      addEventListener('pointerup', () => { if (!down) return; down = false; r.classList.remove('is-dragging'); }, opt);
      r.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, { capture: true, signal: ac.signal });
      r.addEventListener('dragstart', e => e.preventDefault(), opt);
    });

    /* ---------- hero slider ---------- */
    const hero = $('.hero', rootEl);
    if (hero) {
      // fill the screen from where the hero starts, so the dots/arrows are always visible on load
      let fitW = 0;
      const fitHero = force => {
        if (!force && innerWidth === fitW) return; // phones fire resize when the toolbar hides
        fitW = innerWidth;
        const top = hero.getBoundingClientRect().top + scrollY;
        const f = (parseFloat(hero.dataset.height) || 100) / 100;
        // phones: the theme's fixed bottom toolbar covers the screen's last strip, so the hero
        // (and its dots/arrows) ends above it instead of behind it
        const tb = document.querySelector('toolbar-mobile');
        const tbR = tb && getComputedStyle(tb).display !== 'none' ? tb.getBoundingClientRect() : null;
        const tbH = tbR && tbR.height > 0 && tbR.bottom >= innerHeight - 2 ? Math.round(tbR.height) : 0;
        if (top < innerHeight * .6) hero.style.setProperty('--mm-hero-h', Math.max(420, Math.round((innerHeight - top - tbH) * f)) + 'px');
        else hero.style.removeProperty('--mm-hero-h');
      };
      fitHero(true);
      addEventListener('resize', () => fitHero(false), opt);
      addEventListener('load', () => fitHero(true), opt);
      if (document.fonts) document.fonts.ready.then(() => { if (!ac.signal.aborted) fitHero(true); });
      const slides = $$('.hero-slide', hero), dotsWrap = $('[data-hero-dots]', hero), count = $('[data-hero-count]', hero);
      let cur = 0, timer = null;
      const delay = (+hero.dataset.autoplay || 0) * 1000;
      const pad = n => String(n).padStart(2, '0');
      slides.forEach((s, i) => {
        if (dotsWrap) {
          const d = document.createElement('button');
          d.type = 'button'; d.className = 'hero-dot' + (i ? '' : ' is-active'); d.setAttribute('aria-label', `Go to slide ${i + 1}`);
          if (!i) d.setAttribute('aria-current', 'true');
          d.addEventListener('click', () => jump(i), opt);
          dotsWrap.appendChild(d);
        }
        if (i) s.inert = true;
      });
      const dots = dotsWrap ? $$('.hero-dot', dotsWrap) : [];
      // slides after the first are lazy images; one the browser has not fetched yet (the visitor was
      // far down the page when autoplay moved on) would fade in as the bare dark hero background.
      // Fetch the next slide ahead, and switch to a slide only once its image is ready.
      const slideImg = i => slides[i] && $('.hero-img', slides[i]);
      const warm = i => { const img = slideImg((i + slides.length) % slides.length); if (img && img.loading === 'lazy') img.loading = 'eager'; };
      let want = null;
      const show = i => {
        if (!slides.length) return;
        const n = (i + slides.length) % slides.length;
        const img = slideImg(n);
        if (img && !(img.complete && img.naturalWidth)) {
          want = n; warm(n);
          const go = () => { if (want === n && !ac.signal.aborted) { want = null; swap(n); } };
          (img.decode ? img.decode() : Promise.reject()).then(go, () => img.addEventListener('load', go, { once: true }));
          return;
        }
        want = null; swap(n);
      };
      const swap = i => {
        slides[cur].classList.remove('is-active'); slides[cur].inert = true;
        if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].removeAttribute('aria-current'); }
        cur = (i + slides.length) % slides.length;
        slides[cur].classList.add('is-active'); slides[cur].inert = false;
        if (dots[cur]) { dots[cur].classList.add('is-active'); dots[cur].setAttribute('aria-current', 'true'); }
        if (count) count.textContent = pad(cur + 1) + ' / ' + pad(slides.length);
        warm(cur + 1);
      };
      // autoplay pauses while the visitor hovers, has keyboard focus inside, or pressed pause
      const reasons = new Set();
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => { stop(); if (!delay || reduce || designMode || slides.length < 2 || reasons.size) return; timer = setInterval(() => show(cur + 1), delay); };
      const jump = i => { show(i); start(); };
      const pauseBtn = $('[data-hero-pause]', hero);
      const setPaused = (why, on) => {
        on ? reasons.add(why) : reasons.delete(why);
        hero.toggleAttribute('data-paused', reasons.size > 0);
        if (pauseBtn) {
          const user = reasons.has('user');
          pauseBtn.setAttribute('aria-label', user ? 'Play slideshow' : 'Pause slideshow');
          pauseBtn.innerHTML = user ? ICON.play : ICON.pause;
        }
        start();
      };
      if (!delay || reduce || designMode) { hero.setAttribute('data-static', ''); if (pauseBtn) pauseBtn.hidden = true; }
      const next = $('[data-hero-next]', hero), prev = $('[data-hero-prev]', hero);
      if (next) next.addEventListener('click', () => jump(cur + 1), opt);
      if (prev) prev.addEventListener('click', () => jump(cur - 1), opt);
      if (pauseBtn) pauseBtn.addEventListener('click', () => setPaused('user', !reasons.has('user')), opt);
      if (fine) {
        hero.addEventListener('mouseenter', () => setPaused('hover', true), opt);
        hero.addEventListener('mouseleave', () => setPaused('hover', false), opt);
      }
      hero.addEventListener('focusin', e => { if (e.target.matches(':focus-visible')) setPaused('focus', true); }, opt);
      hero.addEventListener('focusout', e => { if (!hero.contains(e.relatedTarget)) setPaused('focus', false); }, opt);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start(), opt);
      // no autoplay while the hero is scrolled out of view: the visitor comes back to the slide they left
      if ('IntersectionObserver' in window) {
        const hio = new IntersectionObserver(([en]) => setPaused('offscreen', !en.isIntersecting));
        hio.observe(hero);
        cleanups.push(() => hio.disconnect());
      }
      // the first slide is in; fetch the second while the visitor reads it
      if (document.readyState === 'complete') warm(1); else addEventListener('load', () => warm(1), { once: true, signal: ac.signal });
      let tx = null;
      hero.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, passive);
      hero.addEventListener('touchend', e => { if (tx == null) return; const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50) jump(cur + (dx < 0 ? 1 : -1)); tx = null; }, opt);
      start();
      cleanups.push(stop);
      rootEl._mmSelect = el => { const i = slides.indexOf(el); if (i > -1) { show(i); stop(); } };
      rootEl._mmDeselect = start;
    }

    /* ---------- trust strip: marquee when the items do not fit ---------- */
    const trust = $('.trust', rootEl), trackEl = $('[data-trust-track]', rootEl);
    if (trust && trackEl) {
      const checkTrust = () => {
        const list = $('.trust-list', trackEl);
        trust.classList.remove('is-marquee');
        $$('.trust-list[aria-hidden]', trackEl).forEach(n => n.remove());
        if (!reduce && list.scrollWidth > trust.clientWidth) {
          const clone = list.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); trackEl.appendChild(clone);
          trust.classList.add('is-marquee');
        }
      };
      let tt = null;
      checkTrust();
      if (document.fonts) document.fonts.ready.then(() => { if (!ac.signal.aborted) checkTrust(); });
      addEventListener('resize', () => { clearTimeout(tt); tt = setTimeout(checkTrust, 200); }, opt);
    }

    /* ---------- showcase: tabs with one panel per sub-collection ---------- */
    const sc = $('.showcase', rootEl);
    if (sc) {
      const tabs = $$('[role="tab"]', sc), imgs = $$('.sc-img', sc), more = $('.sc-more', sc);
      const select = (t, focus) => {
        tabs.forEach((x, i) => {
          const on = x === t;
          x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && imgs.length > 1) imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
        });
        if (more) {
          $('span', more).textContent = (more.dataset.prefix ? more.dataset.prefix + ' ' : '') + t.dataset.label;
          more.href = t.dataset.url || '#';
        }
        if (focus) t.focus();
        refreshST();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t), opt);
        t.addEventListener('keydown', e => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
        }, opt);
      });
      rootEl._mmSelect = el => { if (tabs.includes(el)) select(el); };
      if (!designMode) cleanups.push(unblockSticky($('.sc-edit', sc)));
    }

    /* ---------- monthly edit: pill tabs, one product row per tab ---------- */
    const ed = $('.medit', rootEl);
    if (ed) {
      const tabs = $$('[role="tab"]', ed), note = $('[data-edit-note]', ed), more = $('[data-edit-more]', ed);
      const panelOf = t => document.getElementById(t.getAttribute('aria-controls'));
      const select = (t, focus) => {
        tabs.forEach(x => {
          const on = x === t;
          x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          const p = panelOf(x); if (p) p.hidden = !on;
        });
        if (note) { note.textContent = t.dataset.note || ''; note.hidden = !t.dataset.note; }
        if (more && t.dataset.url) more.href = t.dataset.url;
        if (focus) t.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t), opt);
        t.addEventListener('keydown', e => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
        }, opt);
      });
      // the arrows scroll whichever row is open
      $$('[data-edit-prev],[data-edit-next]', ed).forEach(b => b.addEventListener('click', () => {
        const t = tabs.find(x => x.getAttribute('aria-selected') === 'true');
        const r = t ? panelOf(t) : $('.ed-panel', ed);
        if (!r) return;
        const c = r.firstElementChild;
        const step = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(r).columnGap || 20) : r.clientWidth * .8;
        r.scrollBy({ left: (b.hasAttribute('data-edit-prev') ? -1 : 1) * step, behavior: reduce ? 'auto' : 'smooth' });
      }, opt));
      rootEl._mmSelect = el => { if (tabs.includes(el)) select(el); };
    }

    /* ---------- showrooms: hovering, focusing or tapping a row swaps the photo ---------- */
    const media = $('[data-store-media]', rootEl);
    if (media) {
      const storeImgs = $$('.store-img', media), defImg = $('.store-default', media), badge = $('[data-store-badge]', media);
      const rows = $$('.store', rootEl), list = $('[data-store-list]', rootEl);
      const showStore = i => {
        if (defImg) defImg.classList.toggle('is-on', i == null);
        storeImgs.forEach((im, j) => im.classList.toggle('is-on', String(j) === String(i)));
        rows.forEach(r => r.classList.toggle('is-active', r.dataset.store === String(i)));
        if (badge) {
          const src = i == null ? badge : rows[i];
          badge.innerHTML = '';
          const b = document.createElement('b'); b.textContent = src.dataset.title; badge.append(b, document.createTextNode(src.dataset.text));
        }
      };
      rows.forEach(r => {
        const i = r.dataset.store;
        r.addEventListener('mouseenter', () => showStore(i), opt);
        r.addEventListener('focusin', () => showStore(i), opt);
        r.addEventListener('click', e => { if (!e.target.closest('a')) showStore(i); }, opt);
      });
      if (list) list.addEventListener('mouseleave', () => showStore(null), opt);
      rootEl._mmSelect = el => { const i = rows.indexOf(el); if (i > -1) showStore(String(i)); };
      rootEl._mmDeselect = () => showStore(null);
      if (!designMode) cleanups.push(unblockSticky(media));
    }

    /* ---------- our promise: one panel open at a time (hover, click, tap, keyboard) ---------- */
    $$('.vp-wrap', rootEl).forEach(w => {
      const panels = $$('.vp', w);
      const open = p => panels.forEach(x => {
        const on = x === p;
        x.classList.toggle('is-open', on);
        $('.vp-btn', x).setAttribute('aria-expanded', on);
      });
      panels.forEach(p => {
        $('.vp-btn', p).addEventListener('click', () => open(p), opt);
        $('.vp-btn', p).addEventListener('focus', () => open(p), opt);
        if (fine) p.addEventListener('mouseenter', () => open(p), opt);
      });
      /* back to all closed, equal width, when the pointer or keyboard focus leaves the row */
      if (fine) w.addEventListener('mouseleave', () => open(null), opt);
      w.addEventListener('focusout', e => { if (!w.contains(e.relatedTarget)) open(null); }, opt);
      rootEl._mmSelect = el => { if (panels.includes(el)) open(el); };
    });

    /* ---------- countdown ---------- */
    $$('[data-countdown]', rootEl).forEach(el => {
      const end = new Date(el.dataset.countdown).getTime();
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (isNaN(end) || left <= 0) { el.hidden = true; return false; }
        const s = Math.floor(left / 1000);
        $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
        $('[data-h]', el).textContent = pad(Math.floor(s % 86400 / 3600));
        $('[data-m]', el).textContent = pad(Math.floor(s % 3600 / 60));
        $('[data-s]', el).textContent = pad(s % 60);
        return true;
      };
      if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); cleanups.push(() => clearInterval(t)); }
    });

    /* ---------- reels: the active (centre) reel autoplays muted, one video at a time; also in the
       theme editor and with reduced motion, since the visitor can pause it ----------
       data-kind: file = MP4 (autoplays), yt = YouTube (autoplays muted), ig = Instagram (its player
       loads in the card when play is clicked) */
    const strip = $('[data-reel-strip]', rootEl);
    if (strip) {
      const reels = $$('.reel', strip);
      let current = null, userPaused = false;
      const autoplays = r => !!r._play;
      const setIcon = (r, playing) => {
        const b = $('.reel-play', r); if (!b) return;
        b.innerHTML = playing ? ICON.pause : ICON.play;
        if (autoplays(r)) b.setAttribute('aria-label', (playing ? 'Pause reel: ' : 'Play reel: ') + b.dataset.cap);
      };
      const pauseReel = r => { if (!r._pause) return; r._pause(); r.classList.remove('is-playing'); setIcon(r, false); };
      // every reel with a video plays muted while it is on screen (Instagram links can't autoplay)
      const playReel = r => {
        if (!r._play) return;
        Promise.resolve(r._play()).then(() => { r.classList.add('is-playing'); setIcon(r, true); }).catch(() => { });
      };
      const centre = (r, smooth = true) => strip.scrollTo({ left: r.offsetLeft - (strip.clientWidth - r.offsetWidth) / 2, behavior: smooth && !reduce ? 'smooth' : 'auto' });

      reels.forEach(r => {
        const inner = $('.reel-in', r), capEl = $('.reel-cap', r), tag = capEl && $('small', capEl);
        const kind = r.dataset.kind, link = r.dataset.link && r.dataset.link !== '#' ? r.dataset.link : '';
        const cap = capEl ? (tag ? tag.textContent.trim() + ': ' + capEl.textContent.replace(tag.textContent, '').trim() : capEl.textContent.trim()) : '';
        // the poster is the last image directly in the card (a product poster has a blurred copy before it)
        const poster = $$(':scope > img', inner).pop();
        const addMedia = el => inner.insertBefore(el, poster ? poster.nextSibling : inner.firstChild);
        const play = document.createElement('button');
        play.type = 'button'; play.className = 'reel-play'; play.innerHTML = ICON.play;
        play.dataset.cap = cap;
        inner.appendChild(play);

        if (kind === 'file' && r.dataset.video) {
          const v = document.createElement('video');
          v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none'; v.setAttribute('aria-hidden', 'true');
          addMedia(v);
          r._play = () => { if (!v.getAttribute('src')) v.src = r.dataset.video; return v.play(); };
          r._pause = () => v.pause();
          r._mute = m => { v.muted = m; };
        } else if (kind === 'yt' && r.dataset.embed) {
          // created when the reel first plays; paused / unmuted through the YouTube iframe API messages
          let f = null;
          const cmd = c => { if (f && f.contentWindow) f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: c, args: [] }), '*'); };
          r._play = () => {
            if (!f) {
              f = document.createElement('iframe');
              f.src = r.dataset.embed; f.title = cap || 'Reel'; f.allow = 'autoplay; encrypted-media; picture-in-picture';
              f.tabIndex = -1; f.setAttribute('aria-hidden', 'true');
              addMedia(f);
            } else cmd('playVideo');
          };
          r._pause = () => cmd('pauseVideo');
          r._mute = m => cmd(m ? 'mute' : 'unMute');
        }

        if (r._play) {
          play.setAttribute('aria-label', 'Play reel: ' + cap);
          const snd = document.createElement('button');
          snd.type = 'button'; snd.className = 'reel-sound'; snd.setAttribute('aria-label', 'Turn sound on'); snd.innerHTML = ICON.muted;
          inner.appendChild(snd);
          r._muted = true;
          r._setMuted = m => {
            r._muted = m; r._mute(m);
            snd.setAttribute('aria-label', m ? 'Turn sound on' : 'Turn sound off');
            snd.innerHTML = m ? ICON.muted : ICON.sound;
          };
          snd.addEventListener('click', () => {
            const on = r._muted;
            // only one reel is heard at a time: turning this one up mutes the others
            if (on) reels.forEach(o => { if (o !== r && o._setMuted && !o._muted) o._setMuted(true); });
            r._setMuted(!on);
            if (on) { r._userPaused = false; playReel(r); }
          }, opt);
          play.addEventListener('click', () => {
            if (r.classList.contains('is-playing')) { r._userPaused = true; pauseReel(r); }
            else { r._userPaused = false; playReel(r); }
          }, opt);
        } else {
          play.setAttribute('aria-label', (kind === 'ig' ? 'Watch reel: ' : 'Open on Instagram: ') + cap);
          // "Show Instagram links" off: no Instagram icon link on the card
          if (!rootEl.querySelector('.reels--no-ig')) {
            const ig = document.createElement('a');
            ig.className = 'reel-ig'; ig.href = link || '#'; ig.target = '_blank'; ig.rel = 'noopener';
            ig.setAttribute('aria-label', 'Open on Instagram: ' + cap); ig.innerHTML = ICON.ig;
            inner.appendChild(ig);
          }
          if (kind === 'ig' && r.dataset.embed) {
            // Instagram reel: play loads Instagram's own player inside this card (removed again to stop it)
            let f = null;
            r._pause = () => { if (f) { f.remove(); f = null; } };
            play.addEventListener('click', () => {
              reels.forEach(pauseReel);
              userPaused = true;
              centre(r);
              f = document.createElement('iframe');
              f.className = 'reel-ig-player'; f.src = r.dataset.embed; f.title = cap || 'Instagram reel';
              f.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write'; f.setAttribute('scrolling', 'no');
              addMedia(f);
              r.classList.add('is-playing');
            }, opt);
          } else {
            // no video: play opens the Instagram link (or just centres the card)
            play.addEventListener('click', () => { if (link && !rootEl.querySelector('.reels--no-ig')) window.open(link, '_blank', 'noopener'); else centre(r); }, opt);
          }
        }
      });

      const pickCentre = () => {
        const box = strip.getBoundingClientRect(), mid = box.left + box.width / 2;
        let best = null, bd = Infinity;
        reels.forEach(r => { const b = r.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); if (d < bd) { bd = d; best = r; } });
        if (!best || best === current) return;
        if (current) current.classList.remove('is-center');
        current = best; current.classList.add('is-center');
      };
      let rt = false;
      strip.addEventListener('scroll', () => { if (!rt) { rt = true; requestAnimationFrame(() => { pickCentre(); rt = false; }); } }, passive);
      $$('[data-reel]', rootEl).forEach(b => b.addEventListener('click', () => {
        const i = reels.indexOf(current) + +b.dataset.reel;
        centre(reels[(i + reels.length) % reels.length]);
      }, opt));
      // each reel plays while at least half of it is on screen, and pauses when it scrolls away
      // (a reel the visitor paused stays paused)
      if ('IntersectionObserver' in window) {
        const rio = new IntersectionObserver(entries => entries.forEach(e => {
          const r = e.target;
          if (!autoplays(r)) return;
          if (e.isIntersecting && !r._userPaused) playReel(r);
          else if (!e.isIntersecting) pauseReel(r);
        }), { threshold: .5 });
        reels.forEach(r => rio.observe(r));
        cleanups.push(() => rio.disconnect());
      } else reels.forEach(r => { if (autoplays(r)) playReel(r); });
      // open on the third reel so there are cards on both sides
      cleanups.push(() => reels.forEach(pauseReel));
      if (reels.length) requestAnimationFrame(() => { centre(reels[Math.min(2, reels.length - 1)], false); pickCentre(); });
      addEventListener('resize', () => { if (current) centre(current, false); }, passive);
      rootEl._mmSelect = el => { if (reels.includes(el)) centre(el); };
    }

    /* ---------- signature scroll effects ---------- */
    const needsMotion = $('[data-ink], .hero, .bridal, .craft', rootEl);
    if (needsMotion && !reduce && !designMode) {
      loadLibs().then(G => { if (!ac.signal.aborted) cleanups.push(startMotion(rootEl, G)); }).catch(() => {
        $$('[data-weave]', rootEl).forEach(w => {
          w.classList.remove('is-built');
          $$('.weave-strip', w).forEach(strip => strip.remove());
        });
      });
    }
  }

  /* Pin budget on Home: the craft section only. Everything degrades to static content. */
  function startMotion(rootEl, G) {
    const ST = window.ScrollTrigger;
    const cs = getComputedStyle(rootEl);
    const token = name => cs.getPropertyValue(name).trim();
    const mm = G.matchMedia();
    const ctx = G.context(() => {
      /* ink fill - split words, keep the italic accent */
      $$('[data-ink]', rootEl).forEach(el => {
        const words = [];
        const wrap = (node, acc) => {
          Array.from(node.childNodes).forEach(n => {
            if (n.nodeType === 3) {
              const frag = document.createDocumentFragment();
              n.textContent.split(/(\s+)/).forEach(part => {
                if (!part) return;
                if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
                const s = document.createElement('span'); s.className = 'w' + (acc ? ' acc-w' : ''); s.textContent = part; frag.appendChild(s); words.push(s);
              });
              n.replaceWith(frag);
            } else if (n.nodeType === 1) wrap(n, acc || n.tagName === 'EM' || n.classList.contains('acc'));
          });
        };
        wrap(el, false);
        el.classList.add('ink-on');
        G.to(words, {
          color: (i, w) => (w.classList.contains('acc-w') ? token('--maroon') : token('--mm-ink-heading') || token('--ink')), ease: 'none', stagger: .12,
          scrollTrigger: { trigger: el, start: 'top 82%', end: 'bottom 42%', scrub: .4 }
        });
      });
    }, rootEl);

    /* hero parallax (a scale from the top edge, see mm-home.css) on the browser's own scroll timeline
       where supported, so it keeps pace with the scroll; GSAP below otherwise. */
    const heroEl = $('.hero', rootEl);
    const heroSlides = heroEl && $('.hero-slides', heroEl);
    let heroCssOff = null;
    if (heroSlides && window.CSS && CSS.supports('animation-timeline: scroll()')) {
      const range = () => {
        const top = Math.round(heroEl.getBoundingClientRect().top + scrollY);
        heroSlides.style.setProperty('--mm-px-start', top + 'px');
        heroSlides.style.setProperty('--mm-px-end', top + heroEl.offsetHeight + 'px');
      };
      range();
      heroEl.classList.add('is-px');
      const ro = 'ResizeObserver' in window ? new ResizeObserver(range) : null;
      if (ro) { ro.observe(heroEl); ro.observe(document.body); }
      addEventListener('resize', range);
      heroCssOff = () => {
        if (ro) ro.disconnect();
        removeEventListener('resize', range);
        heroEl.classList.remove('is-px');
        heroSlides.style.removeProperty('--mm-px-start');
        heroSlides.style.removeProperty('--mm-px-end');
      };
    }

    mm.add({ desk: '(min-width: 961px)', mob: '(max-width: 960px)' }, c => {
      const { desk } = c.conditions;

      /* hero: gentle parallax + fade on scroll-out */
      const hero = heroEl;
      if (hero) {
        if (!heroCssOff) G.to(heroSlides, { scale: 1.14, transformOrigin: '50% 0%', ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        G.to($$('.hero-content', hero), { opacity: 0, y: -60, ease: 'none', scrollTrigger: { trigger: hero, start: '30% top', end: '85% top', scrub: true } });
      }

      /* bridal: ground morph paper -> dark, then the photo opens (not pinned): with the silk curtain the
         two drapes part outwards, gathering towards their outer edge; without it the photo unfurls from the centre */
      const bridal = $('.bridal', rootEl);
      if (bridal) {
        const drapes = $('[data-drapes]', bridal);
        const tl = G.timeline({ scrollTrigger: { trigger: bridal, start: 'top 85%', end: desk ? 'top 5%' : 'top 15%', scrub: .6 } })
          .fromTo(bridal, { backgroundColor: token('--ivory') }, { backgroundColor: getComputedStyle(bridal).getPropertyValue('--wine-dark').trim(), ease: 'none', duration: .4 }, 0);
        if (drapes) {
          bridal.classList.add('has-drapes');
          tl.fromTo($('.drape--l', drapes), { xPercent: 0, scaleX: 1, rotate: 0 }, { xPercent: -104, scaleX: .82, rotate: -3, ease: 'power1.in', duration: .8 }, .12)
            .fromTo($('.drape--r', drapes), { xPercent: 0, scaleX: 1, rotate: 0 }, { xPercent: 104, scaleX: .82, rotate: 3, ease: 'power1.in', duration: .8 }, .12)
            .fromTo($('.bridal-media img', bridal), { scale: 1.12 }, { scale: 1, ease: 'none', duration: .92 }, 0);
        } else {
          tl.fromTo($('.bridal-media', bridal), { clipPath: 'inset(0% 41% 0% 41%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', duration: 1 }, 0)
            .fromTo($('.bridal-media img', bridal), { scale: 1.25 }, { scale: 1, ease: 'none', duration: 1 }, 0);
        }
        tl.fromTo($('.bridal-copy', bridal), { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, ease: 'none', duration: .3 }, .7);
      }

      const craft = $('.craft', rootEl);
      if (!desk || !craft) return; // mobile: no pinned scenes

      /* craft - pinned scene: weave -> loom crossfade -> pallu zoom */
      const stage = $('.craft-stage', craft);
      craft.classList.add('is-pinned');
      const strips = $$('.l1 .weave-strip', stage), loom = $$('.l2 > img', stage), steps = $$('.step', craft), rail = $('.steps-rail i', craft);
      G.set(loom.slice(1), { opacity: 0 });
      // step 1: the weave threads in while the section scrolls up to the pin, so the pin opens on a full picture
      if (strips.length) G.fromTo(strips, { xPercent: i => i % 2 ? 105 : -105 }, { xPercent: 0, stagger: .04, ease: 'none', scrollTrigger: { trigger: craft, start: 'top 80%', end: 'top top', scrub: .6 } });
      const ct = G.timeline({ defaults: { ease: 'none' } });
      ct.to({}, { duration: .16 })
        .addLabel('s2')
        .to($('.l2', stage), { opacity: 1, duration: .06 })
        .to(loom[1] || {}, { opacity: 1, duration: .1 }, '+=.06')
        .to(loom[2] || {}, { opacity: 1, duration: .1 }, '+=.06')
        .to({}, { duration: .04 })
        .addLabel('s3')
        .to($('.l3', stage), { opacity: 1, duration: .06 })
        .fromTo($('.pallu-full', stage), { scale: 1 }, { scale: 1.7, duration: .26 })
        .to($('.pallu-close', stage), { opacity: 1, duration: .1 }, '-=.08')
        .to({}, { duration: .05 });
      const s2 = ct.labels.s2 / ct.duration(), s3 = ct.labels.s3 / ct.duration();
      ST.create({
        trigger: craft, start: 'top top', end: '+=150%', pin: true, scrub: .6, animation: ct,
        onUpdate: self => {
          const p = self.progress, a = p < s2 ? 0 : p < s3 ? 1 : 2;
          steps.forEach((s, i) => s.classList.toggle('is-active', i === a));
          if (rail) rail.style.setProperty('--p', p.toFixed(3));
        }
      });
      return () => { craft.classList.remove('is-pinned'); steps.forEach((s, i) => s.classList.toggle('is-active', !i)); if (rail) rail.style.removeProperty('--p'); };
    });

    // late images and fonts change the layout under the triggers
    $$('img', rootEl).forEach(im => { if (!im.complete) im.addEventListener('load', refreshST, { once: true }); });
    refreshST();
    // the drapes only cover the photo while the scroll motion runs
    return () => { mm.revert(); ctx.revert(); if (heroCssOff) heroCssOff(); $$('.bridal.has-drapes', rootEl).forEach(b => b.classList.remove('has-drapes')); };
  }

  /* =====================================================================
     Start + theme editor hooks
     ===================================================================== */
  const initAll = scope => $$('[data-mm-home]', scope || document).forEach(init);
  const boot = () => {
    findHeaders(); setOffset();
    startCursor();
    initAll();
    addEventListener('load', () => { findHeaders(); setOffset(); refreshST(); });
    if (document.fonts) document.fonts.ready.then(refreshST);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', e => { findHeaders(); initAll(e.target); refreshST(); });
  document.addEventListener('shopify:section:unload', e => {
    $$('[data-mm-home]', e.target).forEach(r => { if (r._mmDestroy) r._mmDestroy(); });
    refreshST();
  });
  document.addEventListener('shopify:block:select', e => {
    const r = e.target.closest && e.target.closest('[data-mm-home]');
    if (r && r._mmSelect) r._mmSelect(e.target);
  });
  document.addEventListener('shopify:block:deselect', e => {
    const r = e.target.closest && e.target.closest('[data-mm-home]');
    if (r && r._mmDeselect) r._mmDeselect();
  });
})();
